<template>
  <div id="NewAmenitiesCards">
    <div
      class="newAmenitiesCard"
      v-for="(card, index) in cards"
      :key="'card' + index"
      @click="cardSetter(index)"
    >
      <div class="cardBox">
        <div class="icon">
          <img :src="require('@/assets/svgs/benefits/' + card.icon)" />
        </div>
        <div class="title" v-html="card.title" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AmenitiesCards",
    data() {
      return {
        cards: [
          {
            icon: "newBen-icon-gift.svg",
            title: "Complimentary United Club Season Ticket Member Gift",
            active: false,
          },
          {
            icon: "newBen-icon-ticket.svg",
            title: "Access to complimentary away game tickets* ",
            active: false,
          },
          {
            icon: "newBen-icon-food.svg",
            title: "Improved food & beverage offerings in the United Club Lounge",
            active: false,
          }
        ]
      }
    },
    methods: {
      cardSetter(index) {
        if (!this.cards[index].active) {
          this.cards[0].active = false;
          this.cards[1].active = false;
          this.cards[2].active = false;
          this.cards[3].active = false;
          this.cards[4].active = false;
          this.cards[5].active = false;
          this.cards[6].active = false;
          this.cards[7].active = false;
          this.cards[8].active = false;
          this.cards[9].active = false;
          this.cards[index].active = true;
        } else {
          this.cards[index].active = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #NewAmenitiesCards {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    .newAmenitiesCard {
      // cursor: pointer;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 327px;
      min-height: 189px;
      padding: 30px 25px;
      background: rgba(235, 235, 235, 0.80);
      &:nth-child(2) {
        width: 326px;
      }
      .cardBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          width: 45px;
          height: 39px;
          background: url('~@/assets/svgs/benefits/orange-triangle.svg') scroll no-repeat center center;
          background-size: 45px 39px;
          img {
            position: relative;
            bottom: 4px;
          }
        }
        .title {
          margin-top: 15px;
          font-size: 19px;
          @include nofex;
          line-height: 18px;
          text-align: center;
          color: $orange;
        }
      }
    }
  }
</style>